export const DESKTOP_WIDTH = '1280';
export const TABLET_WIDTH = '768';
export const MOBILE_WIDTH = '480';

export default { TABLET_WIDTH, DESKTOP_WIDTH };
